/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import logo from "../../../../Recursos/logo_barra.svg";
import {theme} from "../../../../Tema";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Valores_Home = ({imagen, titulo, parrafo}) => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                color: 'white',
                textAlign: 'center',


        }}>


            <Grid2 container
                   justifyContent={'center'}
                   size={{xs: 12, sm: 12, md: 12}}
                   >
                <img
                    src={imagen} width={100} height={'auto'}
                    style={{cursor: 'pointer', fill: theme.palette.primary.main}}
                />
            </Grid2>

            <Grid2 container
                   justifyContent={'center'}
                   size={12} sx={{marginTop: 2}} >
                <Typography sx={{fontWeight: 600, fontSize: sCell ? 30 : 32}}  >
                    {titulo}
                </Typography>
            </Grid2>

            <Grid2 container
                   size={{xs: 12, sm: 12, md: 12}}>
                <Typography sx={{fontSize: sCell ? 16 : 18}}>
                    {parrafo}
                </Typography>
            </Grid2>

        </Grid2>
    )

}
export default Tarjeta_Valores_Home